import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  backButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  backButton: {
    color: theme.palette.primary.main,
  },
  backIcon: {
    color: theme.palette.primary.red,
    fontSize: 'clamp(12px, 1.60vw, 34px)',
    fontWeight: 700,
  },
  studentName: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  title: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: '#5BC2D5',
    fontFamily: 'Montserrat',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(12px, 1.56vw, 32px)',
  },
  relevantStudentInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '20px',
  },
  borderBox: {
    boxShadow: '0px 0px 4px 0px #00000040',
    borderRadius: '10px',
    padding: '20px',
  },
  relevantStudentInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },
  studentRelevantInfoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  relevantStudentInfoTitle: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  relevantStudentInfoText: {
    fontSize: 'clamp(8px, 1.04vw, 21px)',
    fontWeight: 400,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  programsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  programsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  addProgramButton: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 'clamp(8px, 1.04vw, 21px)',
    padding: 0,
    width: 'clamp(118px, 15.31vw, 314px)',
    height: 'clamp(20px, 2.60vw, 53px)',
    textTransform: 'none',
  },
  matriculaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    padding: '20px',
  },
  matriculaInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 'clamp(12px, 1.60vw, 34px)',
  },
  matriculaInputs: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(12px, 1.60vw, 34px)',
    width: '100%',
    maxWidth: 'clamp(191px, 24.80vw, 512px)',
    '& input, & .MuiSelect-select': {
      padding: 'clamp(5px, 0.63vw, 13px) clamp(6px, 0.83vw, 17px) !important',
    },
  },
  matriculaResult: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    width: '100%',
    maxWidth: '477px',
  },
  matriculaResultTitle: {
    fontFamily: 'Montserrat',
    fontSize: '25px',
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  matriculaPriceOriginal: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    verticalAlign: 'middle',
    textDecoration: 'line-through',
    color: theme.palette.text.primary,
  },
  matriculaPriceFinal: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: 'clamp(14px, 1.82vw, 37px)',
    verticalAlign: 'middle',
    color: theme.palette.text.primary,
  },
  adornmentTextCurrency: {
    fontFamily: 'Varela Round',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: '16px',
    verticalAlign: 'middle',
    color: theme.palette.primary.main,
  },
  centeredLabelTextField: {
    '& .MuiInputLabel-root': {
      top: '50%',
      transform: 'translate(14px, -50%)',
      transformOrigin: 'left center',
      '&.MuiInputLabel-shrink': {
        top: 0,
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
  },
}));

export default useStyles;
